import React, { useCallback, useEffect, useState } from 'react';
import { useCountDown, useUnmount } from 'ahooks';
import { ScreenBrightness } from '@capacitor-community/screen-brightness';
import { Icon } from '@fuxi/eevee-icon';
import { useDevice } from '@/hooks';
import { SocketClientType } from '@/service/socketio';
import svgImg from '@/assets/image/aruco-marker.svg';

import cx from './index.module.scss';

interface Props {
  socketInstance: React.MutableRefObject<SocketClientType>;
  // 直接显示marker不显示倒计时
  directShowMarker: boolean;
  onShowMarker: VoidFunc;
}

const MarkerContent: React.FC<Props> = ({ socketInstance, directShowMarker, onShowMarker }) => {
  const [countdown] = useCountDown({ leftTime: 5 * 1000, onEnd: () => onShowMarker?.() });
  const [coord, setCoord] = useState(null);
  const { info } = useDevice();

  useUnmount(() => {
    info?.platform === 'android' && ScreenBrightness.setBrightness({ brightness: -1 });
  });

  const sendRequest = useCallback(
    async (x: number, y: number) => {
      try {
        await socketInstance.current?.setHandEyePixelCoordinate({ x, y });
      } catch (e) {
        console.log('error', e);
      }
    },
    [socketInstance]
  );

  useEffect(() => {
    if (!coord?.x) return;
    sendRequest(coord?.x, coord?.y);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coord]);

  useEffect(() => {
    info?.platform === 'android' && ScreenBrightness.setBrightness({ brightness: 0 });
  }, [info?.platform]);

  return (
    <div
      className={cx('MarkerContent')}
      onTouchStart={e => {
        const touchX = Math.round(e.touches[0].clientX);
        const touchY = Math.round(e.touches[0].clientY);
        setCoord({
          x: touchX,
          y: touchY,
        });
      }}
      onTouchMove={e => {
        const touchX = Math.round(e.touches[0].clientX);
        const touchY = Math.round(e.touches[0].clientY);
        setCoord({
          x: touchX,
          y: touchY,
        });
      }}
    >
      <Icon className={cx('left-arrow')} name="arrow-top" size={250} />

      {countdown < 500 || directShowMarker ? (
        <img src={svgImg} alt="" width={650} />
      ) : (
        <div className={cx('sec')}>{Math.round(countdown / 1000)}</div>
      )}

      <Icon className={cx('right-arrow')} name="arrow-top" size={250} />
    </div>
  );
};

export default MarkerContent;
